// import React from 'react'
// import T from 'prop-types'
// import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
//
// import IconButton from './IconButton'

export default function DownloadBar() {
  // {
  // eslint-disable no-empty-pattern
  // readOnly,
  // handleDownload = () => {},
  // disabled = false,
  // }
  return false

  // return (
  //   <IconButton
  //     data-testid="download-button"
  //     onClick={handleDownload}
  //     variant="outlined"
  //     disabled={disabled}
  //   >
  //     <FileDownloadOutlinedIcon />
  //   </IconButton>
  //   // <Stack direction="row" justifyContent="flex-end">
  //   //   <Link
  //   //     component="button"
  //   //     variant="body2"
  //   //     color="textPrimary"
  //   //     onClick={handleDownload}
  //   //     sx={{ textDecoration: 'none' }}
  //   //   >
  //   //     <Stack direction="row" alignItems="center">
  //   //       <DownloadIcon />
  //   //       {t('sessions.download')}
  //   //     </Stack>
  //   //   </Link>
  //   // </Stack>
  // )
}

// DownloadBar.propTypes = {
//   readOnly: T.bool,
//   handleDownload: T.func,
// }
